import React, { useState, useEffect, useRef } from "react";
import Preloader from "../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { addDays, format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../components/MessageBox/MessageBox";
import ButtonComponent from "react-button-component";
import LoadingOverlay from "react-loading-overlay";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import numeral from "numeral";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DynamicTable from "../../components/DynamicTable";
import { DateRangePicker } from "materialui-daterange-picker";
import { checkDateRange } from "../../services/utils";
const useStyles = makeStyles((theme) => ({
  btnSearch: {
    marginTop: 30,
    backgroundColor: "green",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  field: {
    width: "100%",
    marginBottom: "1rem",
  },
}));
const FranchiseTransactionHistory = (props) => {
  const refDataFilter = useRef(null);
  const toggle = () => setOpen3(!open3);
  const [posts, setPosts] = useState([]);
  const [isCodesonly, setIscodesonly] = useState({
    iscodesonly: props.match.params.iscodesonly
      ? props.match.params.iscodesonly
      : 0,
  });
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });

  const [filterOption, setFilterOption] = useState({
    idno_filter: "",
    relstats_filter: "",
    soldto_filter: "",
    accttype_filter: "",
    country_filter: "",
    delivery_filter: "",
    package_filter: "",
    promo_filter: "",
    packstats_filter: "",
  });

  const classes = useStyles();
  const iscodesonlysummary = props.match.params.iscodesonly
    ? props.match.params.iscodesonly
    : 0;
  const [nextPagePath, setNextPagePath] = useState("");
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [idnoselected, setIdnoSelected] = useState("");
  const [eligibleforrelease, setEligibleRel] = useState("");
  const [isFS, setIfFS] = useState("");
  const [isLoaded, setisLoaded] = useState();
  const [releaseidno, setReleaseIdno] = useState("");
  const [selectedpackagetype, setSelectedPackageType] = useState("");
  const [current_pageName, setCurrent_pageName] = useState(
    "Wholesale Set Transaction History"
  );

  const [checkMaxDays, setCheckMaxDays] = useState(false);

  //Dropdown Filter
  const [hideDate, sethideDate] = useState(true);
  const [hideIdno, sethideIdno] = useState(false);
  const [hideRelStatus, sethideRelStatus] = useState(false);
  const [hideSoldto, sethideSoldto] = useState(false);
  const [hideActType, sethideActType] = useState(false);
  const [hideCountry, sethideCountry] = useState(false);
  const [hideDelTarget, sethideDelTarget] = useState(false);
  const [hidePackage, sethidePackage] = useState(false);
  const [hidePromo, sethidePromo] = useState(false);
  const [hidePackStatus, sethidePackStatus] = useState(false);
  const [releaseCO, setReleaseSingleCO] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  //Dropdown Filter
  const min_releasedate = "2023-01-17";
  const nextpage = {
    // pathname: "/package-sales-payment",
    pathname: nextPagePath,
    idno: idnoselected,
    eligibleforrelease: eligibleforrelease,
    isfs: isFS,
  };
  const nextpageEncoding = {
    isCORelease: "yes",
  };
  const headers = {
    "Content-Type": "multipart/form-data",
  };
  //ApiData Component useState SOF
  const get_accttype = () => {
    setisLoaded(true);
    //get data for warehouse/location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "accttypelist";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadAccttype(res.data.accttype);
    });
  };

  //   const checkDateRange = (d1, d2) => {
  //     // To calculate the time difference of two dates
  //     var Difference_In_Time = d1.getTime() - d2.getTime();

  //     // To calculate the no. of days between two dates
  //     var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

  //     return Difference_In_Days;
  //   };

  const dateRangeHandler = (range) => {
    console.log("Date Range", range);
    if (checkDateRange(range.endDate, range.startDate) <= 30) {
      setDateRange(range);
    } else {
      setCheckMaxDays(true);
      setTimeout(() => {
        setCheckMaxDays(false);
      }, 6000);
    }

    setOpen3(false);
  };

  const get_country = () => {
    //get data for shipping location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "countrylist";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadCountry(res.data.country);
    });
  };

  const get_promocode = () => {
    //get data for shipping location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "promocodelist";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPromocode(res.data.promocode);
    });
  };

  const get_packageavailed = () => {
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "packageavailedlist";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPackageAvailed(res.data.packageavailed);
    });
  };

  const package_sales_summary = () => {
    setisLoaded(false);
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      prep_data: prep_data,
      iscodesonly: iscodesonlysummary,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "packagesalessummary";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPackageSalesList(res.data);
    });
  };

  const releasepackage = (idno) => {
    setShowOverlay(true);
    setOverlayMsg("Processing Release...");
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      idno: idno,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "releasepackage";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      if (res.data.result.success == 1) {
        setShowMsgBox(true);
        setMsg(res.data.result.message);
        setMsgType("success");
        setTimeout(() => {
          setShowOverlay(false);
          setOverlayMsg("");
          setShowMsgBox(false);
          refreshTable();
          // window.location.reload(false);
          onFetchedApi();
          // setisLoaded(true);
        }, 3000);
        // onFetchedApi();
        //  window.location.reload(false);
      } else {
        onFetchedApi();
        setisLoaded(true);
        setShowMsgBox(true);
        setMsg(res.data.result.message);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
        }, 3000);
      }
    });
    // onFetchedApi();
  };

  const get_codesonly_details = (idno, packagetype) => {
    setShowOverlay(true);
    setOverlayMsg("Fetching Data...");
    //get data for warehouse/location dropdown
    const form_data = {
      idno: idno,
      promocode: promoCode,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl =
      process.env.REACT_APP_API_URL + "getcodesonlyencodingdetails";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      nextpageEncoding["pageInfo"] = res.data.pageInfo;
      nextpageEncoding["transactionInfo"] = res.data.transactionInfo;
      proceedtoencoding();
    });
  };
  //ApiData Component useState EOF
  const [accttype_dropdown, loadAccttype] = useState([]);
  const [country_dropdown, loadCountry] = useState([]);
  const [promocode_dropdown, loadPromocode] = useState([]);
  const [packageavailed_dropdown, loadPackageAvailed] = useState([]);

  const selectAccttypeProps = {
    options: accttype_dropdown,
    getOptionLabel: (option) => option.atype,
  };

  const selectCountryProps = {
    options: country_dropdown,
    getOptionLabel: (option) => option.countryname,
  };

  const selectPromocodeProps = {
    options: promocode_dropdown,
    getOptionLabel: (option) => option.nav_name,
  };

  const selectPackageAvailedProps = {
    options: packageavailed_dropdown,
    getOptionLabel: (option) => option.description,
  };

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  const [refreshKey, setRefreshKey] = useState(0);
  
  //Loading overlay
  const [showOverlay, setShowOverlay] = useState(false);
  const [overLayMsg, setOverlayMsg] = useState(false);
  //Loading overlay EOF

  //Table Settings
  const [TABLE_DATA, loadDataTable] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});

  const loadPackageSalesList = (data) => {
    refreshTable();
    const newData = [...TABLE_DATA];
    for (let i = 0; i < data.packagesalessummary.length; i++) {
      if (
        data.rawpackagesalessummary[i].status == 1 ||
        data.rawpackagesalessummary[i].status == 8 ||
        data.rawpackagesalessummary[i].status == 2 ||
        data.rawpackagesalessummary[i].status == 3 ||
        data.rawpackagesalessummary[i].status == 6
      ) {
        if (
          data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
          data.rawpackagesalessummary[i].date >= min_releasedate &&
          data.rawpackagesalessummary[i].packageid != 0 &&
          get_cookies("can_process") == 1
        ) {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      confirmrelease(
                        data.packagesalessummary[i][2],
                        data.rawpackagesalessummary[i].packageid,
                        data.packagesalessummary[i][4]
                      );
                    }}
                  >
                    Release
                  </Button>
                </Grid>
                <Grid xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "yes",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        } else if (
          data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
          data.rawpackagesalessummary[i].date >= min_releasedate &&
          data.rawpackagesalessummary[i].packageid == 0 &&
          get_cookies("can_process") == 1
        ) {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      confirmrelease(
                        data.packagesalessummary[i][2],
                        data.rawpackagesalessummary[i].packageid,
                        data.packagesalessummary[i][4],
                        data.rawpackagesalessummary[i].promocode
                      );
                    }}
                  >
                    Release
                  </Button>
                </Grid>
                <Grid xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "no",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        } else {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "no",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        }
      } else if (data.rawpackagesalessummary[i].status == 4) {
        if (data.rawpackagesalessummary[i].packageid == -1) {
          if (
            data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
            data.rawpackagesalessummary[i].date >= min_releasedate &&
            get_cookies("can_process") == 1
          ) {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  <Grid xs={12} sm={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        confirmrelease(
                          data.packagesalessummary[i][2],
                          data.rawpackagesalessummary[i].packageid,
                          data.packagesalessummary[i][4]
                        );
                      }}
                    >
                      Release
                    </Button>
                  </Grid>
                  <Grid xs={12} sm={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "yes",
                          ""
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          } else {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  <Grid xs={12} sm={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "no",
                          ""
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          }
        } else {
          if (
            data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
            data.rawpackagesalessummary[i].date >= min_releasedate
          ) {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  {/* <Grid xs={12} sm={6}>
                                                        <Button variant="contained" color="primary" onClick={(e) => {confirmrelease(data.packagesalessummary[i][2],data.rawpackagesalessummary[i].packageid,data.packagesalessummary[i][4])}}>Release</Button>
                                                    </Grid> */}
                  <Grid xs={12} sm={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "no",
                          "fs"
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          } else {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  <Grid xs={12} sm={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "no",
                          "fs"
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          }
        }
      } else if (data.rawpackagesalessummary[i].status == 5) {
        if (
          data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
          data.rawpackagesalessummary[i].date >= min_releasedate &&
          get_cookies("can_process") == 1
        ) {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      confirmrelease(
                        data.packagesalessummary[i][2],
                        data.rawpackagesalessummary[i].packageid,
                        data.packagesalessummary[i][4]
                      );
                    }}
                  >
                    Release
                  </Button>
                </Grid>
                <Grid xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "yes",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        } else {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "no",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        }
      }
    }
    loadDataTable([...newData]);
    setisLoaded(true);
  };

  const refreshTable = () => {
    // TABLE_DATA.length = 0;
    // const newData = [...TABLE_DATA];
    // loadDataTable([...newData]);
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const onFetchedApi = () => {
    console.log('di',refDataFilter.current);
    refDataFilter.current.onFetchApi();
  };

  const columns = [
    {
      name: "date",
      label: "Date",
    },
    {
      name: "soldto",
      label: "Sold To",
    },
    {
      name: "idno",
      label: "ID No.",
    },
    {
      name: "runningtotal",
      label: "Amount",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
              <div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
          );
          }
        }
    },
    {
      name: "atype",
      label: "Account Type",
    },
    {
      name: "promocode",
      label: "Account Type Name",
    },
    {
      name: "action",
      label: "Action",
      options: {
        setCellProps: () => ({
          style: { minWidth: "180px", maxWidth: "180px" },
        }),
        customBodyRenderLite: (data) => {
          let packageid = posts[data].packageid;
          let status = posts[data].status;
          let releaseddate = posts[data].releaseddate;
          let date = posts[data].date;

          if (
            status == 1 ||
            status == 8 ||
            status == 2 ||
            status == 3 ||
            status == 6
          ) {
            if (
              releaseddate == "0000-00-00" &&
              date >= min_releasedate &&
              packageid != 0
            ) {
              if (get_cookies("can_process") == 1) {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          confirmrelease(
                            posts[data].idno,
                            posts[data].packageid,
                            posts[data].atype
                          )
                        }
                      >
                        Release
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "yes", "")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              } else {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "yes", "")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              }
            } else if (
              releaseddate == "0000-00-00" &&
              date >= min_releasedate &&
              packageid == 0
            ) {
              if (get_cookies("can_process") == 1) {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          confirmrelease(
                            posts[data].idno,
                            posts[data].packageid,
                            posts[data].atype,
                            posts[data].promocode
                          )
                        }
                      >
                        Release
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "no", "")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              } else {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "no", "")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              }
            } else {
              return (
                <Grid container spacing={1}>
                  <Grid item>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={(e) =>
                        viewpackagedetails(posts[data].idno, "no", "")
                      }
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              );
            }
          } else if (status == 4) {
            if (packageid == -1) {
              if (releaseddate == "0000-00-00" && date >= min_releasedate) {
                if (get_cookies("can_process") == 1) {
                  return (
                    <Grid container spacing={1}>
                      <Grid item>
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={(e) =>
                            confirmrelease(
                              posts[data].idno,
                              posts[data].packageid,
                              posts[data].atype
                            )
                          }
                        >
                          View
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={(e) =>
                            viewpackagedetails(posts[data].idno, "yes", "")
                          }
                        >
                          View
                        </Button>
                      </Grid>
                    </Grid>
                  );
                } else {
                  return (
                    <Grid container spacing={1}>
                      <Grid item>
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={(e) =>
                            viewpackagedetails(posts[data].idno, "yes", "")
                          }
                        >
                          View
                        </Button>
                      </Grid>
                    </Grid>
                  );
                }
              } else {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "no", "")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              }
            } else {
              if (releaseddate == "0000-00-00" && date >= min_releasedate) {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "no", "fs")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              } else {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "no", "fs")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              }
            }
          } else if (status == 5) {
            if (releaseddate == "0000-00-00" && date >= min_releasedate) {
              if (get_cookies("can_process") == 1) {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          confirmrelease(
                            posts[data].idno,
                            packageid,
                            posts[data].atype
                          )
                        }
                      >
                        Release
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "yes", "")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              } else {
                return (
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={(e) =>
                          viewpackagedetails(posts[data].idno, "yes", "")
                        }
                      >
                        View
                      </Button>
                    </Grid>
                  </Grid>
                );
              }
            } else {
              return (
                <Grid container spacing={1}>
                  <Grid item>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={(e) =>
                        viewpackagedetails(posts[data].idno, "no", "")
                      }
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              );
            }
          }
        },
        filter: false,
        sort: false,
      },
    },
  ];

  const TABLE_OPTION = {
    selectableRows: "none",
  };
  //Table Settings EOF

  //Modal Settings
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  //Modal Settings EOF
  const formatDate = (date) => {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  //FormData
  const [prep_data, setData] = useState({
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
  });
  //FormData EOF
  //OnLoad Event/Data Fetching SOF
  useEffect(() => {
    isLoggedIn();
    onFetchedApi();
    get_packageavailed();
    get_promocode();
    get_country();
    get_accttype();
    clearState();
    // if (iscodesonlysummary > 0) {
    //   setCurrent_pageName("Package Sales Transaction History (Codes Only)");
    //   nextpageEncoding["isCORelease"] = "yes";
    // }
  }, []);
  //OnLoad Event/Data Fetching SOF

  // Date Picker
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const startDateChanged = (e) => {
    setStartDate(e);
    const newData = { ...prep_data };
    newData["startDate"] = formatDate(e);
    setData({ ...newData });
    setDateRange((prevState) => ({ ...prevState, startDate: formatDate(e) }));
  };
  const endDateChanged = (e) => {
    setEndDate(e);
    const newData = { ...prep_data };
    newData["endDate"] = formatDate(e);
    setData({ ...newData });
    setDateRange((prevState) => ({ ...prevState, endDate: formatDate(e) }));
  };

  const viewpackagedetails = (idno, eligible, fs) => {
    setNextPagePath("/Franchise-transaction-details");
    setIdnoSelected(idno);
    if (eligible == "yes") {
      setEligibleRel("yes");
    } else {
      setEligibleRel("");
    }
    if (fs == "fs") {
      setIfFS("fs");
    } else {
      setIfFS("");
    }
    proceedtopackagedetails();
  };

  const set_package_encoding = () => {
    nextpageEncoding["pathname"] = "/package-sales-information";
    get_codesonly_details(releaseidno, selectedpackagetype + "SET");
  };

  const cyop_encoding = () => {
    nextpageEncoding["pathname"] = "/package-sales-item";
    get_codesonly_details(releaseidno, selectedpackagetype + "CYOP");
  };

  useEffect(() => {
    props.history.push(nextpage);
  }, [nextPagePath]);

  const proceedtopackagedetails = () => {
    props.history.push(nextpage);
  };

  const proceedtoencoding = () => {
    props.history.push(nextpageEncoding);
  };

  const confirmrelease = (idno, packageid, packagetype, promocode = "PCO") => {
    setReleaseIdno(idno);
    setSelectedPackageType(packagetype);
    if (packageid == 0) {
      if (promocode == "PCO" || promocode == "SCO") {
        setPromoCode(promocode);
        setReleaseSingleCO(false);
      } else {
        setPromoCode(promocode);
        setReleaseSingleCO(true);
      }
      handleOpen2();
    } else {
      handleOpen();
    }
  };
  const prepData_initialState = {
    idno_filter: "",
    relstats_filter: "",
    soldto_filter: "",
    accttype_filter: "",
    country_filter: "",
    delivery_filter: "",
    package_filter: "",
    promo_filter: "",
    packstats_filter: "",
    iscodesonly: "",
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
  };

  const clearState = () => {
    setData({ ...prepData_initialState });
  };
  //Dropdown Filter Value
  const filterList = [
    { description: "Transaction Date", id: "date_filter" },
    { description: "IDNO", id: "idno_filter" },
    { description: "Release Status", id: "relstats_filter" },
    { description: "Sold To", id: "soldto_filter" },
    { description: "Activation Type", id: "accttype_filter" },
    { description: "Country", id: "country_filter" },
    { description: "Delivery Type", id: "delivery_filter" },
    { description: "Package Availed", id: "package_filter" },
    { description: "Promo Code", id: "promo_filter" },
    { description: "Package Status", id: "packstats_filter" },
  ];
  const releaseStatusList = [
    { description: "All", id: "" },
    { description: "For Release", id: 2 },
    { description: "Released", id: 1 },
  ];
  const deliveryList = [
    { description: "All", id: "" },
    { description: "Pick Up", id: 1 },
    { description: "Delivery", id: 2 },
    { description: "Toktok", id: 30 },
  ];
  const display_filters = (a, b, c, d, e, f, g, h, i, j) => {
    sethideDate(a);
    sethideIdno(b);
    sethideRelStatus(c);
    sethideSoldto(d);
    sethideActType(e);
    sethideCountry(f);
    sethideDelTarget(g);
    sethidePackage(h);
    sethidePromo(i);
    sethidePackStatus(j);
  };
  const clearStateSpecific = (nametoclear) => {
    const newData = { ...prep_data };
    newData[nametoclear] = "";
    setData({ ...newData });
  };
  const onFilterChange = (selectedFilter) => {
    //clear prep_data value if not selected
    clearState();
    setStartDate(new Date());
    setEndDate(new Date());
    switch (selectedFilter) {
      case "date_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "idno_filter":
        display_filters(
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "relstats_filter":
        display_filters(
          true,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "soldto_filter":
        display_filters(
          true,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "accttype_filter":
        display_filters(
          true,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "country_filter":
        display_filters(
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          false
        );
        break;
      case "delivery_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false
        );
        break;
      case "package_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false
        );
        break;
      case "promo_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false
        );
        break;
      case "packstats_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
          true,
          true
        );
        break;

      default:
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
    }
  };

  const onInputChange = (event) => {
    const newData = { ...prep_data };
    newData[event.target.name] = event.target.value;
    setData({ ...newData });
    setFilterOption({ ...newData });
  };
  //Date Picker EOF
  return (
    <div className="page">
      <LoadingOverlay active={showOverlay} spinner text={overLayMsg}>
        <div className="page-header">
          <div className="page-icon">
            <ShoppingCartIcon />
          </div>
          <Breadcrumbs aria-label="breadcrumb">
            <NavLink to="/wholesale">
              <h2 className="header-title">Wholesale Set</h2>
            </NavLink>
            <Typography color="textPrimary">{current_pageName}</Typography>
          </Breadcrumbs>
        </div>
        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
        <div className="page-container">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                autoComplete
                options={filterList}
                getOptionLabel={(option) => option.description}
                includeInputInList
                className={classes.autoComplete}
                name="filterList"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Filters"
                    margin="normal"
                    variant="outlined"
                  />
                )}
                onChange={(event, newValue) => {
                  if (!newValue == "" || !newValue == null) {
                    onFilterChange(newValue.id);
                  }
                }}
              />
            </Grid>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              {hideDate ? (
                <Grid item xs={12} sm={3}>
                  <TextField
                    id="outlined-basic"
                    label="Select Date"
                    variant="outlined"
                    margin="normal"
                    onFocus={() => setOpen3(true)}
                    fullWidth={true}
                    autoComplete="off"
                    value={`${format(
                      dateRange.startDate,
                      "MM/dd/yyyy"
                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                  />
                  <DateRangePicker
                    open={open3}
                    toggle={toggle}
                    onChange={(range) => dateRangeHandler(range)}
                  />
                </Grid>
              ) : null}
            </MuiPickersUtilsProvider>
            {hideIdno ? (
              <Grid item xs={12} sm={3}>
                <TextField
                  name="idno_filter"
                  label="IDNO"
                  variant="outlined"
                  type="text"
                  margin="normal"
                  className={classes.field}
                  onChange={onInputChange}
                />
              </Grid>
            ) : null}
            {hideRelStatus ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  name="relstats_filter"
                  autoComplete
                  options={releaseStatusList}
                  getOptionLabel={(option) => option.description}
                  includeInputInList
                  className={classes.autoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Release Status"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      //code here
                      const newData = {
                        ...prep_data,
                      };
                      newData["relstats_filter"] = newValue.id;
                      setData({ ...newData });
                      setFilterOption({ ...newData });
                    } else {
                      clearStateSpecific("relstats_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hideSoldto ? (
              <Grid item xs={12} sm={3}>
                <TextField
                  name="soldto_filter"
                  label="Sold To"
                  variant="outlined"
                  type="text"
                  margin="normal"
                  className={classes.field}
                  onChange={onInputChange}
                />
              </Grid>
            ) : null}
            {hideActType ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  {...selectAccttypeProps}
                  autoComplete
                  includeInputInList
                  className={classes.autoComplete}
                  name="accttype_filter"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Activation Type"
                      margin="normal"
                      variant="outlined"
                      required="true"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      const newData = {
                        ...prep_data,
                      };
                      newData["accttype_filter"] = newValue.atype;
                      setData({ ...newData });
                      setFilterOption({ ...newData });
                    } else {
                      clearStateSpecific("accttype_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hideCountry ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  {...selectCountryProps}
                  autoComplete
                  includeInputInList
                  className={classes.autoComplete}
                  name="country_filter"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country"
                      margin="normal"
                      variant="outlined"
                      required="true"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      const newData = {
                        ...prep_data,
                      };
                      newData["country_filter"] = newValue.countryname;
                      setData({ ...newData });
                      setFilterOption({ ...newData });
                    } else {
                      clearStateSpecific("country_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hideDelTarget ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  name="delivery_filter"
                  autoComplete
                  options={deliveryList}
                  getOptionLabel={(option) => option.description}
                  includeInputInList
                  className={classes.autoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Delivery Type"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      //code here
                      const newData = {
                        ...prep_data,
                      };
                      newData["delivery_filter"] = JSON.stringify(
                        newValue.id,
                        null,
                        " "
                      );
                      setData({ ...newData });
                      setFilterOption({ ...newData });
                    } else {
                      clearStateSpecific("delivery_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hidePackage ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  {...selectPackageAvailedProps}
                  autoComplete
                  includeInputInList
                  className={classes.autoComplete}
                  name="package_filter"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Package Availed"
                      margin="normal"
                      variant="outlined"
                      required="true"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      const newData = {
                        ...prep_data,
                      };
                      newData["package_filter"] = JSON.stringify(
                        newValue.id,
                        null,
                        " "
                      );
                      setData({ ...newData });
                      setFilterOption({ ...newData });
                    } else {
                      clearStateSpecific("package_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hidePromo ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  {...selectPromocodeProps}
                  autoComplete
                  includeInputInList
                  className={classes.autoComplete}
                  name="promo_filter"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Promo Code"
                      margin="normal"
                      variant="outlined"
                      required="true"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      const newData = {
                        ...prep_data,
                      };
                      newData["promo_filter"] = newValue.nav_code;
                      setData({ ...newData });
                      setFilterOption({ ...newData });
                    } else {
                      clearStateSpecific("promo_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={3}>
              <Button
                variant="contained"
                color="primary"
                className={classes.btnSearch}
                onClick={(e) => {
                  onFetchedApi();
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "10px" }}>
            {/* { 
                    !isLoaded ?  <Preloader /> :										
                    <MUIDataTable
                        title={
                            <div>
                                <div className="table-title">
                                    Package Sales Transaction History
                                </div>
                            </div>
                        }
                        id="table-grid"
                        data={TABLE_DATA}
                        columns={TABLE_COLUMNS}
                        options={TABLE_OPTION}
                    />
                } */}

            {
              // !isLoaded ?  <Preloader /> :
              <DynamicTable
              key={refreshKey}
                title="Wholesale Set"
                columns={columns}
                rows={posts}
                setRows={setPosts}
                ref={refDataFilter}
                dateRange={dateRange}
                iscodesonly={isCodesonly}
                filterOption={filterOption}
                url="wholesale_transaction_history"
              />
            }
          </Grid>
        </div>
      </LoadingOverlay>
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">System Message</h2>
              <form action="" className={classes.root}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    Are you sure you want to release this package?
                  </Grid>
                </Grid>
                <div className={classes.button}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={2}>
                      <Button
                        variant="contained"
                        onClick={handleClose}
                        className={classes.buttonMarginRight}
                      >
                        No
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                          releasepackage(releaseidno);
                          handleClose();
                        }}
                      >
                        Yes
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </div>
          </Fade>
        </Modal>
      </div>
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open2}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open2}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">
                Choose Transaction First to Proceed
              </h2>
              <form action="" className={classes.root}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      className={classes.buttonMarginRight}
                      onClick={set_package_encoding}
                    >
                      Set Package
                    </Button>
                  </Grid>
                  {!releaseCO ? (
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        className={classes.buttonMarginRight}
                        onClick={cyop_encoding}
                      >
                        Choose Your Own Package
                      </Button>
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>
                <div className={classes.button}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Button
                        variant="contained"
                        onClick={handleClose2}
                        className={classes.buttonMarginRight}
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          float: "right",
                          marginTop: "10px",
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </div>
          </Fade>
        </Modal>
      </div>
      <MessageBox
        in={checkMaxDays}
        content="Maximum of 30 days date range. Kindly select again."
        type="warning"
      />
      ;
    </div>
  );
};

export default FranchiseTransactionHistory;
